import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
//路由参数配置
//同级路由配置  name属性相同即可
//模板消息进入配置 back属性  back可以传递参数
//一级路由配置 root属性
//返回路由带参数 params
//定义返回路由层级  count  即当前路由与之前路由之间的层级数
Router.prototype.routeBack = function (params,count) {
  let routeTrack = JSON.parse(window.sessionStorage['routeTrack']);
  let c  = count ?　count : 0;
  let length = routeTrack.children.length;
  if(length == 0 || length == 1){
    this.push({path : routeTrack.root});
  }else{
    routeTrack.children.forEach((v,i)=>{
      if(v.fullPath == this.history.current.fullPath){
        if(i-1-c < 0 ){
          this.push({path : '/home/myPatients'});
          console.log('返回层级不存在，即将返回根目录！');
        }else{
          this.push({path : routeTrack.children[i-1-c].fullPath , query : params});
        }
      }
    })
  }
}
const route =  new Router({
  mode: 'history',
  routes: [
    {
      path : '/',
      redirect : '/login'
    },
    {
      path : '/login',
      name : 'login',
      component : resolve => require(['../pages/login/login'], resolve),
    },
    {
      path : '/newWriteArtical',
      name : 'newWriteArtical',
      component : resolve => require(['../pages/newWriteArtical/newWriteArtical'], resolve),
    },
    {
      path : '/home',
      name : 'home',
      component : resolve => require(['../pages/home/home'], resolve),
      children : [
        {
          path : 'myPatients',
          name : 'myPatients',
          redirect : '/home/myPatients/patientsList',
          component : resolve => require(['../pages/myPatients/myPatients'], resolve),
          children : [
            {
              path : 'patientsList',
              name : 'patientsList',
              component : resolve => require(['../pages/patientsList/patientsList'], resolve),
              children:[
                {
                  path : ':chat_hx_account/patientInfo',
                  name : 'patientInfo',
                  component : resolve => require(['../pages/patientInfo/patientInfo'], resolve),
                  meta : { clearLocal : ['caseCardAnswerAll']}
                },
                {
                  path : ':chat_hx_account/patientService',
                  name : 'patientService',
                  component : resolve => require(['../pages/patientService/patientService'], resolve)
                },
                {
                  path : ':chat_hx_account/childCaseInfoCard/:answer_id/patientInfo',
                  name : 'childCaseInfoCard',
                  component : resolve => require(['../pages/childCaseInfoCard/childCaseInfoCard'], resolve),
                },
                {
                  path : ':chat_hx_account/preCaseInfoCard/:answer_id/patientInfo',
                  name : 'preCaseInfoCard',
                  component : resolve => require(['../pages/preCaseInfoCard/preCaseInfoCard'], resolve),
                }
              ]
            },
            {
              path : 'patientReport',
              name : 'patientReport',
              component : resolve => require(['../pages/patientReport/patientReport'], resolve),
            }
          ]
        },
        {
          path : 'myConsult',
          name : 'myConsult',
          redirect : '/home/myConsult/1/consultList',
          component : resolve => require(['../pages/myConsult/myConsult'], resolve),
          children :[
            {
              path : ':status/consultList',
              name : 'consultList',
              component : resolve => require(['../pages/consultList/consultList'], resolve),
              children:[
                {
                  path : ':chat_hx_account/chat',
                  name : 'chat',
                  component : resolve => require(['../pages/chat/chat'], resolve),
                }
              ]
            }
          ]
        },
        {
          path : 'myOrder',
          name : 'myOrder',
          redirect : '/home/myOrder/1/orderList',
          component : resolve => require(['../pages/myOrder/myOrder'], resolve),
          children :[
            {
              path : ':status/orderList',
              name : 'orderList',
              component : resolve => require(['../pages/orderList/orderList'], resolve),

            }
          ]
        },
        {
          path : 'myScience',
          name : 'myScience',
          redirect : '/home/myScience/myScienceLibrary',
          component : resolve => require(['../pages/myScience/myScience'], resolve),
          children :[
            {
              path : 'myScienceLibrary',
              name : 'myScienceLibrary',
              component : resolve => require(['../pages/myScienceLibrary/myScienceLibrary'], resolve),
              children:[
                {
                  path : ':id/:status/collectScienceArticle',
                  name : 'collectScienceArticle',
                  component : resolve => require(['../pages/collectScienceArticle/collectScienceArticle'], resolve),
                },
              ]

            },
            {
              path : ':type/scienceLibrary',
              name : 'scienceLibrary',
              component : resolve => require(['../pages/scienceLibrary/scienceLibrary'], resolve),
              children:[
                {
                  path : ':id/:status/collectScienceArticle',
                  name : 'collectScienceArticle',
                  component : resolve => require(['../pages/collectScienceArticle/collectScienceArticle'], resolve),
                },
              ]
            },
            {
              path : 'addArtical',
              name : 'addArtical',
              component : resolve => require(['../pages/addArtical/addArtical'], resolve),
            },
            {
              path : 'uploadArtical',
              name : 'uploadArtical',
              component : resolve => require(['../pages/uploadArtical/uploadArtical'], resolve),

            },
            {
              path : 'writeAriticle',
              name : 'writeAriticle',
              component : resolve => require(['../pages/writeAriticle/writeAriticle'], resolve),

            },

          ]
        },
        {
          path : 'changeInfo',
          name : 'changeInfo',
          component : resolve => require(['../pages/changeInfo/changeInfo'], resolve),
        },
        {
          path : 'working',
          name : 'working',
          component : resolve => require(['../pages/working/working'], resolve),
        },
        {
          path : 'myQRcode',
          name : 'myQRcode',
          component : resolve => require(['../pages/myQRcode/myQRcode'], resolve),
        },
        {
          path: 'research',
          name: 'research',
          component: resolve => require(['../pages/research/research'], resolve),
          children: [
            {
              path: '/',
              name: 'count',
              component: resolve => require(['../pages/research/researchCount'], resolve),
            },
            {
              path: 'card/:paper_answer_id',
              name: 'card',
              component: resolve => require(['../pages/research/researchCard'], resolve),
            }
          ]
        }
      ]
    },
    {
      path : '/register',
      name : 'register',
      component : resolve => require(['../pages/register/register'], resolve),
    },
    {
      path : '/setPassword',
      name : 'setPassword',
      component : resolve => require(['../pages/setPassword/setPassword'], resolve),
    },
    {
      path : '/protocol',
      name : 'protocol',
      component : resolve => require(['../pages/protocol/protocol'], resolve),
    },
    {
      path : '/addInfo',
      name : 'addInfo',
      component : resolve => require(['../pages/addInfo/addInfo'], resolve),
    },
    {
      path : '/:status/successTip',
      name : 'successTip',
      component : resolve => require(['../pages/successTip/successTip'], resolve),
    },
    {
      path : '/versionTip',
      name : 'versionTip',
      component : resolve => require(['../pages/versionTip/versionTip'], resolve),
    },
    {
      path : '/wxAuthPhone',
      name : 'wxAuthPhone',
      component : resolve => require(['../pages/wxAuthPhone/wxAuthPhone'], resolve),
    },
    {
      path : '/:phone/wxAuthSetPassword',
      name : 'wxAuthSetPassword',
      component : resolve => require(['../pages/wxAuthSetPassword/wxAuthSetPassword'], resolve),
    },
    {
      path : '/:status/wxBindTip',
      name : 'wxBindTip',
      component : resolve => require(['../pages/wxBindTip/wxBindTip'], resolve),
    },
    {
      path : '/test',
      name : 'test',
      component : resolve => require(['../pages/test/test'], resolve),
    }
  ]
})
route.beforeEach((to,from,next)=>{
  if(window.sessionStorage['routeTrack']){
    global.ROUTELENGTH = JSON.parse(window.sessionStorage['routeTrack']).children.length;
  }
  if(to.meta.hasOwnProperty('root')){
    if(to.meta.root){
      window.sessionStorage['routeTrack'] =  JSON.stringify({root : to.fullPath , children :[]});
    }
  }else{
    if(!window.sessionStorage['routeTrack']){
      if(to.meta.back){
        window.sessionStorage['routeTrack'] =  JSON.stringify({root : to.meta.back, children :[]});
      }else{
        window.sessionStorage['routeTrack'] =  JSON.stringify({root : '/home/myPatients', children :[]});
      }
    }
    let routeTrack = JSON.parse(window.sessionStorage['routeTrack']);
    //判断原有路由是否存在相同路由
    let result = routeTrack.children.some((v,i)=>{
      if(v.name == to.name){
        routeTrack.children.splice(i+1,);
        routeTrack.children[i] = {name : to.name , fullPath : to.fullPath};
      }
      return v.name == to.name;
    })
    if(!result){
      routeTrack.children.push({name : to.name , fullPath : to.fullPath});
    }
    window.sessionStorage['routeTrack'] = JSON.stringify(routeTrack);
  }
  if(to.path == '/hwNoJump'){}else{
    next();
  }

})

export default route;



// WEBPACK FOOTER //
// ./src/router/index.js